var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountIntegration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49999 5.60002C8.00284 5.60002 6.79999 6.79939 6.79999 8.2663C6.79999 9.7332 8.00284 10.9326 9.49999 10.9326C10.9971 10.9326 12.2 9.7332 12.2 8.2663C12.2 6.79939 10.9971 5.60002 9.49999 5.60002ZM5.59999 8.2663C5.59999 6.12506 7.35175 4.40002 9.49999 4.40002C11.6482 4.40002 13.4 6.12506 13.4 8.2663C13.4 10.4075 11.6482 12.1326 9.49999 12.1326C7.35175 12.1326 5.59999 10.4075 5.59999 8.2663ZM7.29999 14.4655C5.80324 14.4655 4.59999 15.6652 4.59999 17.1334C4.59999 17.8329 5.1671 18.4 5.86666 18.4H13.1333C13.8329 18.4 14.4 17.8329 14.4 17.1334C14.4 15.6652 13.1968 14.4655 11.7 14.4655H7.29999ZM3.39999 17.1334C3.39999 14.9913 5.15167 13.2655 7.29999 13.2655H11.7C13.8483 13.2655 15.6 14.9913 15.6 17.1334C15.6 18.4957 14.4956 19.6 13.1333 19.6H5.86666C4.50436 19.6 3.39999 18.4957 3.39999 17.1334Z",
    fill: "#A3B0C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 8.40002C17.8314 8.40002 18.1 8.66865 18.1 9.00002V10.9H20C20.3314 10.9 20.6 11.1687 20.6 11.5C20.6 11.8314 20.3314 12.1 20 12.1H18.1V14C18.1 14.3314 17.8314 14.6 17.5 14.6C17.1686 14.6 16.9 14.3314 16.9 14V12.1H15C14.6686 12.1 14.4 11.8314 14.4 11.5C14.4 11.1687 14.6686 10.9 15 10.9H16.9V9.00002C16.9 8.66865 17.1686 8.40002 17.5 8.40002Z",
    fill: "#A3B0C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIntegration);
export default __webpack_public_path__ + "static/media/account-integration.fe72a1fe689bb00bc01c4201c3b40b00.svg";
export { ForwardRef as ReactComponent };